"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateMedicareEligibility = exports.useUpdateMedicaidEligibility = void 0;
var _useRequest3 = require("../../../utils/useRequest");
var _endpoints = require("../../../utils/endpoints");
var _toast = require("../../../utils/toast");
var useUpdateMedicareEligibility = function useUpdateMedicareEligibility(clinicianId, _ref) {
  var _onSuccess = _ref.onSuccess;
  var _useRequest = (0, _useRequest3.useRequest)(function (states) {
      return {
        url: (0, _endpoints.getClinicianMedicareEligibilityUrl)(clinicianId),
        method: 'patch',
        data: {
          states: states
        }
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _toast.toast.success({
          title: 'Success!',
          description: 'Saved clinician Medicare eligibility'
        });
        _onSuccess();
      },
      onError: function onError(error) {
        _toast.toast.error({
          title: 'Something went wrong',
          description: error.response.data.message
        });
      }
    }),
    saveMedicareEligibility = _useRequest.run,
    saving = _useRequest.loading;
  return {
    saving: saving,
    save: saveMedicareEligibility
  };
};
exports.useUpdateMedicareEligibility = useUpdateMedicareEligibility;
var useUpdateMedicaidEligibility = function useUpdateMedicaidEligibility(clinicianId, _ref2) {
  var _onSuccess2 = _ref2.onSuccess;
  var _useRequest2 = (0, _useRequest3.useRequest)(function (states) {
      return {
        url: (0, _endpoints.getClinicianMedicaidEligibilityUrl)(clinicianId),
        method: 'patch',
        data: {
          states: states
        }
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _toast.toast.success({
          title: 'Success!',
          description: 'Saved clinician Medicaid eligibility'
        });
        _onSuccess2();
      },
      onError: function onError(error) {
        _toast.toast.error({
          title: 'Something went wrong',
          description: error.response.data.message
        });
      }
    }),
    saveMedicaidEligibility = _useRequest2.run,
    saving = _useRequest2.loading;
  return {
    saving: saving,
    save: saveMedicaidEligibility
  };
};
exports.useUpdateMedicaidEligibility = useUpdateMedicaidEligibility;